import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { AccuracyComponent } from "./accuracy.component";
import { AccuracyRoutingModule } from "./accuracy-routing.module";
import { DxChartModule, DxDataGridModule, DxTextAreaModule, DxRangeSelectorModule, DxSwitchModule } from "devextreme-angular";
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { BookmarkModule } from "src/app/widgets/bookmark/bookmark.module";
import { DxTableControllerDirective } from "src/app/directives/dx-table-controller.directive";
import { WebExportModule } from "src/app/widgets/web-export/web.export.module";

@NgModule({
	declarations: [AccuracyComponent],
	imports: [
		CommonModule,
		DxChartModule,
		DxTextAreaModule,
		DxRangeSelectorModule,
		DxDataGridModule,
		DevEpressCommonModule,
		AccuracyRoutingModule,BookmarkModule ,DxSwitchModule,
		DxTableControllerDirective,
		WebExportModule
	],
})
export class AccuracyModule { }
